export default "__VITE_ASSET__xvEIysVQ__"